<template>
  <div class="ec" v-if="list.length">
    <div class="ec-title">
      <div class="title_dian">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="txt">Activities</div>
    </div>
    <div class="ec-content">
      <Swipe class="my-swipe" :autoplay="500000" :show-indicators="false" indicator-color="'#ddd'">
        <template v-for="(item, i) in list.slice(0, 3)">
          <SwipeItem :key="i">
            <div class="brand-list grid1-2" v-if="pageSize == 2">
              <div class="brand-list-one" v-for="(c, index) in item" :key="'c-' + index" @click="LinkAct(c)">
                <div class="one-img">
                  <img :src="c.banners" v-if="c.banners" v-load="'oActSmall'" />
                  <img v-else src="@/assets/img/empty.png" />
                </div>
                <div class="one-compname">{{ c.title }}</div>
              </div>
              <div class="brand-list-one" v-for="(c, index) in [1, 1].splice(0, pageSize - item.length)" :key="'z' + index" v-if="item.length < pageSize"></div>
            </div>

            <div class="brand-list grid1-3" v-if="pageSize == 3">
              <div class="brand-list-one" v-for="(c, index) in item" :key="'c-' + index" @click="LinkAct(c)">
                <div class="one-img">
                  <img :src="c.banners" v-if="c.banners" v-load="'oActSmall'" />
                  <img v-else src="@/assets/img/empty.png" />
                </div>
                <div class="one-compname">{{ c.title }}</div>
              </div>
              <div class="brand-list-one" v-for="(c, index) in [1, 1, 1].splice(0, pageSize - item.length)" :key="'z' + index" v-if="item.length < pageSize"></div>
            </div>

            <div class="brand-list grid2-2" v-if="pageSize == 4">
              <div class="brand-list-one" v-for="(c, index) in item" :key="'c-' + index" @click="LinkAct(c)">
                <div class="one-img">
                  <img :src="c.banners" v-if="c.banners" v-load="'oActSmall'" />
                  <img v-else src="@/assets/img/empty.png" />
                </div>
                <div class="one-compname">{{ c.title }}</div>
              </div>
              <div class="brand-list-one" v-for="(c, index) in [1, 1, 1, 1].splice(0, pageSize - item.length)" :key="'z' + index" v-if="item.length < pageSize"></div>
            </div>

            <div class="brand-list grid2-3" v-if="pageSize == 6">
              <div class="brand-list-one" v-for="(c, index) in item" :key="'c-' + index" @click="LinkAct(c)">
                <div class="one-img">
                  <img :src="c.banners" v-if="c.banners" v-load="'oActSmall'" />
                  <img v-else src="@/assets/img/empty.png" />
                </div>
                <div class="one-compname">{{ c.title }}</div>
              </div>
              <div class="brand-list-one" v-for="(c, index) in [1, 1, 1, 1, 1, 1].splice(0, pageSize - item.length)" :key="'z' + index" v-if="item.length < pageSize"></div>
            </div>
          </SwipeItem>
        </template>
      </Swipe>
    </div>
  </div>
</template>

<script>
import { Swipe, SwipeItem } from "vant";
import { mapGetters, mapActions } from "vuex";
import gql from "graphql-tag";
export default {
  name: "together-act",
  props: {
    rule: {
      type: Object,
      default: {
        lineRule: [
          { value: "1/2", label: "1行2列" },
          { value: "1/3", label: "1行3列" },
          { value: "2/2", label: "2行2列" },
          { value: "2/3", label: "2行3列" },
        ],
        line: "1/2", // 1/3 1行三列； 1/4 1行四列； 2/3 2行3列；2/4 2行4列
      },
    },
  },
  data() {
    return {
      pageSize: 2,
      list: [],
      actList: [],
      activityQuery: {},
    };
  },
  components: {
    Swipe,
    SwipeItem,
  },
  created() {
    this.setRow();
  },
  computed: {
    ...mapGetters({
      exonId: "getExhibitionId",
      exhibitionConfig: "getExhibitionConfig",
    }),
    exhibitionId() {
      return this.$route.params.id || this.exonId;
    },
  },
  methods: {
    ...mapActions({
      LinkAct: "linkTo/LinkAct",
    }),
    setRow() {
      switch (this.rule.line) {
        case "1/2":
          this.pageSize = 2;
          break;
        case "1/3":
          this.pageSize = 3;
          break;
        case "2/2":
          this.pageSize = 4;
          break;
        case "2/3":
          this.pageSize = 6;
          break;
        default:
          this.pageSize = 2;
          break;
      }
    },
    init() {
      const query = gql`
        query($query: QueryInput!) {
          activityQuery {
            query(query: $query) {
              hasNextPage
              pageIndex
              items {
                acvitityType
                externalLink
                hasLive
                liveAuditState
                id
                title
                titleEn
                banners
                liveStateIndex #活动进行状态 1：进行中、2：未开始：3：已结束
                banners #
              }
            }
          }
        }
      `;
      let where = {
        equal_auditState: {
          n: "auditState",
          v: 1,
        },
        equal_exhibitionId: {
          n: "exhibitionId",
          v: this.exhibitionId,
        },
        equal_isExhibitionActivity: {
          n: "isExhibitionActivity",
          v: 0,
        },
        notEqual_topic: {
          n: "topic",
          v: 0,
        },
      };
      let order = [
        {
          n: "topic",
          v: 0,
        },
        {
          n: "topicIndex",
          v: 0,
        },
        {
          n: "auditTime",
          v: 0,
        },
      ];
      let opt = {
        page: 1,
        size: 20,
        where: JSON.stringify(where),
        order: JSON.stringify(order),
      };
      this.$apollo.addSmartQuery("activityQuery", {
        query: query,
        variables: {
          query: opt,
        },
        fetchPolicy: "network-only", //清理缓存
        result(res) {
          let data = JSON.parse(JSON.stringify(res.data.activityQuery.query));
          if (data) {
            let ExArr = [];
            data.items.forEach((e, i) => {
              const c = Math.floor(i / this.pageSize);
              if (!ExArr[c]) {
                ExArr[c] = [];
              }
              if (e.banners && e.banners.indexOf("[") != -1) {
                let arr = JSON.parse(e.banners);
                e.banners = arr[0];
              }
              ExArr[c].push(e);
            });
            this.list = ExArr;
            this.$emit("requestOk", "compListIsOk");
          }
        },
        error(err) {},
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ec {
  background: #fff;
  margin-bottom: 15px;
  &-title {
    padding: 0.25rem 0.3rem;
    display: flex;
    align-items: center;
    font-size: 0.3rem;
    color: #333;
    .title_dian {
      display: flex;
      justify-content: space-between;
      width: 0.06rem;
      height: 0.24rem;
      flex-direction: column;
      margin-right: 0.1rem;
      span {
        width: 0.06rem;
        height: 0.06rem;
        display: block;
        border-radius: 0.02rem;
        background-image: linear-gradient(90deg, #ff4b1b 0%, #fe781d 100%), linear-gradient(#108ee9, #108ee9);
        &:nth-child(1) {
          opacity: 0.5;
        }
        &:nth-child(2) {
          opacity: 0.75;
        }
      }
    }
    img {
      width: 13px;
    }
    .txt {
      font-size: 0.3rem;
      font-weight: bold;
    }
  }
  &-content {
    padding: 0;
    background: #fff;
    .brand-list {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin: 0 15px;
      &-one {
        background-color: #fff;
        margin-bottom: 0.3rem;
        position: relative;
        .one-img {
          border-radius: 0.1rem;
          overflow: hidden;
          box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.1);
          padding-bottom: 56%;
          position: relative;
          img {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
          }
        }
        .one-compname {
          margin-top: 0.14rem;
          color: #333;
          font-size: 0.26rem;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          width: 100%;
        }
      }
    }
  }
}

.my-swipe {
  ::v-deep {
    .van-swipe__indicators {
      bottom: 1px;
    }
    .van-swipe__indicator {
      background-color: #ddd;
    }
    .van-swipe__indicator--active {
      background-color: #fe781d;
    }
    .van-swipe__track {
      padding-bottom: 0.1rem;
    }
  }
}
.grid1-2,
.grid2-2 {
  .brand-list-one {
    width: 48%;
  }
}
.grid1-3,
.grid2-3 {
  .brand-list-one {
    width: 32%;
  }
}
</style>
